import { Menu, MenuItem, MenuItemType, MenuModes } from '../../typings/menu';
import { SearchDriveItemState } from '../DriveItemList/Search/reducer';
import { SharePanelState } from '../Share/reducer';

enum CancelActionOrigin {
	Search = 'search',
	Share = 'share',
	Theater = 'theater'
}

const defaultGalleryMenu: Menu = {
	default: {
		burger: [
			{ type: MenuItemType.Home },
			{ type: MenuItemType.Gallery },
			{ type: MenuItemType.Selection },
			{ type: MenuItemType.New },
			{ type: MenuItemType.Downloads },
			{ type: MenuItemType.Parameters }],
		left: [{ type: MenuItemType.BurgerButton }],
		center: [{ type: MenuItemType.Logo }],
		right: [
			{ type: MenuItemType.SearchButton },
			{ type: MenuItemType.ShareButton },
			{ type: MenuItemType.DownloadButton }]
	}
} as Menu;

const defaultAppMenu: Menu = {
	default: {
		burger: [
			{ type: MenuItemType.Home },
			{ type: MenuItemType.New },
			{ type: MenuItemType.Selection },
			{ type: MenuItemType.Documents },
			{ type: MenuItemType.SharedWithMe },
			{ type: MenuItemType.Parameters }],
		left: [{ type: MenuItemType.BurgerButton }],
		center: [{ type: MenuItemType.Logo }],
		right: [
			{ type: MenuItemType.SearchButton },
			{ type: MenuItemType.UpdateFolderTreeButton },
			{ type: MenuItemType.Documents },
			{ type: MenuItemType.Selection }]
	},
	mobile: {
		burger: [
			{ type: MenuItemType.SearchButton },
			{ type: MenuItemType.Home },
			{ type: MenuItemType.New },
			{ type: MenuItemType.Selection },
			{ type: MenuItemType.Documents },
			{ type: MenuItemType.SharedWithMe },
			{ type: MenuItemType.Parameters }],
		left: [{ type: MenuItemType.BurgerButton }],
		center: [{ type: MenuItemType.Logo }],
		right: [
			{ type: MenuItemType.UpdateFolderTreeButton },
			{ type: MenuItemType.Selection }
		]
	},
} as Menu;

const getActionOrigin = (isSearch: boolean): CancelActionOrigin => {
	return isSearch ? CancelActionOrigin.Search : CancelActionOrigin.Share;
};

const getLabel = (origin: CancelActionOrigin): string => {
	return origin === CancelActionOrigin.Search ? 'messages.search' : 'messages.share';
};

const getActionBarMenu = (origin: CancelActionOrigin): MenuModes => {
	const title = { type: MenuItemType.Title, label: getLabel(origin) } as MenuItem;
	const cancelButton = { type: MenuItemType.CancelButton, target: origin } as MenuItem;

	return {
		burger: [],
		left: [],
		center: [title],
		right: [cancelButton]
	};
};

const getHeaderMenuModes = (search: SearchDriveItemState, sharePanel: SharePanelState, managerMenuModes: MenuModes): MenuModes => {
	const { isShown } = search;
	const { isOpen } = sharePanel;
	const isActionBar = isShown || isOpen;
	return isActionBar ? getActionBarMenu(getActionOrigin(isShown)) : managerMenuModes;
};

export { CancelActionOrigin, defaultGalleryMenu, defaultAppMenu, getHeaderMenuModes };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/constants.ts